import React from "react";

import { Text } from "src/library/components/Text";

export interface NoPriceChangeDataFoundProps {
  name?: string;
  code?: string;
}

const NoPriceChangeDataFound: React.ReactFCWithChildren<NoPriceChangeDataFoundProps> = ({ name, code }) => {
  return (
    <Text>
      {`No price change data ${name && code ? `associated with ${name} (${code}).` : "found."}`}
    </Text>
  );
};

export default NoPriceChangeDataFound;
